import { IconImage } from 'bold-ui'
import {
  tipoDomicilioEnumRecord,
  tipoLocalizacaoEnumRecord,
} from 'components/form/field/select/CondicoesMoradiaSelectFields/condicoes-moradia-model'
import { ACOMPANHAMENTO_TERRITORIO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { MapMarkerModel } from 'components/map/map-model'
import { TipoDomicilioEnum, TipoImovelEnum, TipoLocalizacaoEnum } from 'graphql/types.generated'
import { matchPath } from 'react-router-dom'
import { isUndefinedOrNull } from 'util/checks'
import { humanizeDate } from 'util/date/humanize-date'
import { formatNumber } from 'util/number'
import { isTipoImovelResidencial } from 'view/cadastro-imovel/utils-cadastroImovel'

import { MapaTerritorioMarker } from './components/MapaTerritorioMarker'
import { getNumeroMoradoresFormatado } from './formatters-territorioMapa'
import {
  MAPA_DO_TERRITORIO_ROUTE,
  MAPA_SIDEBAR_NAV_ITEM_ROUTE,
  MapaSidebarNavItemEnum,
  PINO_TERRITORIO_MODAL_ROUTE,
  TerritorioPinoComCoordenadas,
  TerritorioPinoModel,
} from './model-territorioMapa'

export function possuiCoordenadas(imovel: TerritorioPinoModel): imovel is TerritorioPinoComCoordenadas {
  return imovel.latitude != null && imovel.longitude != null
}

export function toMapMarkerModel(imovel: TerritorioPinoComCoordenadas): MapMarkerModel {
  return {
    id: imovel.id,
    coordinates: [imovel.longitude, imovel.latitude],
    content: <MapaTerritorioMarker imovel={imovel} />,
  }
}

export function toMapMarkers(imoveis: ReadonlyArray<TerritorioPinoModel>): MapMarkerModel[] {
  return imoveis.filter(possuiCoordenadas).map(toMapMarkerModel)
}

export function getImovelModalHeaderTags(
  tipoImovel: TipoImovelEnum | null,
  tipoDomicilio: TipoDomicilioEnum | null,
  tipoLocalizacao: TipoLocalizacaoEnum | null,
  numeroMoradores: number | null,
  dataUltimaVisita: LocalDate | null,
  possuiOutrosProfsVinculados: boolean
): { icon?: IconImage; label: string | null }[] {
  const tags: { icon?: IconImage; label: string | null }[] = []

  if (tipoDomicilio) {
    tags.push({ label: tipoDomicilioEnumRecord[tipoDomicilio] })
  }

  if (tipoLocalizacao) {
    tags.push({ label: tipoLocalizacaoEnumRecord[tipoLocalizacao] })
  }

  if (isUndefinedOrNull(numeroMoradores)) {
    tags.push({ icon: 'userFilled', label: 'Sem registro de morador' })
  }

  if (tipoImovel && isTipoImovelResidencial(tipoImovel) && !isUndefinedOrNull(numeroMoradores)) {
    tags.push({ icon: 'userFilled', label: getNumeroMoradoresFormatado(numeroMoradores) })
  }

  if (possuiOutrosProfsVinculados) {
    tags.push({ icon: 'medicalCrossFilled', label: 'Outros profissionais de saúde vinculados' })
  }

  if (dataUltimaVisita) {
    tags.push({ label: `Última visita: ${humanizeDate(dataUltimaVisita)}` })
  } else {
    tags.push({ label: 'Sem registro de última visita' })
  }

  return tags
}

export function formatResults(total: number): string {
  return `${formatNumber(total)} ${total === 1 ? 'resultado' : 'resultados'}`
}

export const isPinoTerritorioPath = (pathname: string): boolean =>
  !!matchPath(pathname, {
    path: `${ACOMPANHAMENTO_TERRITORIO_PATH}/${MAPA_DO_TERRITORIO_ROUTE}/:mapaSidebarNavItem?/${PINO_TERRITORIO_MODAL_ROUTE}/:imovelId(\\d+)`,
    exact: true,
  })

export function parseMapaSidebarNavItem(routeParam: string | undefined): MapaSidebarNavItemEnum {
  return (
    Object.values(MapaSidebarNavItemEnum).find((navItem) => MAPA_SIDEBAR_NAV_ITEM_ROUTE[navItem] === routeParam) ??
    MapaSidebarNavItemEnum.BUSCA
  )
}
